import React from 'react';
import ActionButton from '../../components/ActionButton';

const ProductSelectorTabs = ({ type, action }) => <div className='block selector-buttons button-tabs'>
    {['Subscription', 'Premium', 'Multiroom', 'Receiver','Equipment'].map((value, key) => {
        const className = type === value.toLowerCase()? "selected": "";
        return <ActionButton title={value} key={key} className={className} action={() => action(value.toLowerCase())}/>
    })
}
</div>

export default ProductSelectorTabs;